'use client';

export { default } from './TableRow';
export { default as tableRowClasses } from './tableRowClasses';
export * from './tableRowClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableRow/index.js
// module id = 899
// module chunks = 22